import { Link } from "react-router-dom";
import type { ReviewSite } from "@/mocks/reviews";

function badgeColor(badge?: string) {
  if (badge === "避雷警示") return "bg-red-500/90 text-background-50";
  return "bg-secondary-500 text-background-50";
}

export default function ReviewCard({ site, index }: { site: ReviewSite; index?: number }) {
  return (
    <Link
      to={`/reviews/${site.slug}`}
      className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative overflow-hidden">
        <img
          src={site.img}
          alt={`${site.name}漫画网站评测封面`}
          title={`${site.name} · 漫画网站推荐评测`}
          className="h-44 w-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        {site.badge && (
          <span className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-semibold ${badgeColor(site.badge)}`}>
            {site.badge}
          </span>
        )}
        {index !== undefined && (
          <span className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-foreground-950/70 font-display text-sm text-background-50">
            {index + 1}
          </span>
        )}
      </div>

      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-center justify-between gap-2">
          <h3 className="font-display text-base text-foreground-950">{site.name}</h3>
          <span className="flex items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-900">
            <i className="ri-star-fill text-accent-600"></i>
            {site.rating}
          </span>
        </div>
        <p className="mt-1 text-xs text-secondary-700">{site.category}</p>
        <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">{site.summary}</p>

        <div className="mt-auto pt-4">
          <div className="flex items-center gap-1.5">
            <span className="flex items-center gap-1 text-xs text-foreground-500">
              <i className="ri-advertisement-line text-secondary-600"></i>
              广告 {site.ads.score}
            </span>
            <span className="text-foreground-300">·</span>
            <span className="flex items-center gap-1 text-xs text-foreground-500">
              <i className="ri-speed-line text-accent-600"></i>
              加载 {site.speed.score}
            </span>
          </div>
          <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
            查看详细评测
            <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}